import React from 'react';
import { Button } from './ui/Button';
export function WhyPremier() {
  return <section className="py-20 bg-primary text-white text-center" data-id="element-276">
      <div className="container mx-auto px-4" data-id="element-277">
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-278">
          Why Premier World Discovery?
        </h2>
        <p className="text-lg md:text-xl text-blue-100 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-279">
          For over three decades, we've specialized in creating exceptional
          group travel experiences with personalized service and attention to
          detail. We are 100% dedicated to the group travel market.
        </p>

        <div className="flex flex-wrap justify-center gap-4" data-id="element-280">
          <Button variant="outline" className="border-white text-white hover:bg-white hover:text-primary" data-id="element-281">
            The Premier Difference
          </Button>
          <Button variant="outline" className="border-white text-white hover:bg-white hover:text-primary" data-id="element-282">
            Our 10 Commitments
          </Button>
          <Button variant="outline" className="border-white text-white hover:bg-white hover:text-primary" data-id="element-283">
            Travel Styles
          </Button>
        </div>
      </div>
    </section>;
}